const CreateDropDown_mutate = `
  mutation createDropdown(
    $label: String!
    $formId: Int!
    $mandatory: Boolean
    $caption: String
    $tooltip: String   
    $options: [String!]!
    ) {
    createDropdown(
      label: $label,
      formId: $formId,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,      
      options: $options) 
      {
        component {
          componentId
          caption
          tooltip
          order
          label
          mandatory          
        }
      }
    }
`;

const EditDropDown_mutate = `
  mutation editDropdown(
    $componentId: Int!
    $label: String!  
    $mandatory: Boolean
    $caption: String
    $tooltip: String
    $options: [String!]!
    ) {
    editDropdown(
      componentId: $componentId,
      label: $label,
      mandatory: $mandatory,
      caption: $caption,
      tooltip: $tooltip,
      options: $options) 
      {
        component {
          componentId
          answerList{
            answerId 
            label
            value
          }
          caption
          tooltip
          order
          label
          mandatory          
        }
      }
    }
`;

module.exports = {
  CREATE_DROPDOWN_MUTATION : CreateDropDown_mutate,
  EDIT_DROPDOWN_COMPONENT_MUTATION : EditDropDown_mutate,
}
